import { useParams } from 'react-router-dom'

import FeatureTour from 'models/FeatureTour'

import NotFound from 'pages/NotFound'
import FeatureTourForm from 'pages/shared/FeatureTourForm'

import useFeatureTours from 'hooks/useFeatureTours'

import Brand from 'helpers/brand'

import { LoadingSinglePanePage, SinglePanePage } from 'styles/shared'

const EditFeatureTour = () => {
  const brands = Brand.allBrandsOfCurrentBusinessUnit()
  const { featureTours, areFeatureToursLoaded } = useFeatureTours(brands, false, false)

  const { id } = useParams()

  if (!areFeatureToursLoaded) {
    return <LoadingSinglePanePage />
  }

  const featureTour = _.find(featureTours, (featureTour) => featureTour.id.toString() === id)
  if (!featureTour) {
    return (
      <SinglePanePage>
        <NotFound />
      </SinglePanePage>
    )
  }

  return (
    <SinglePanePage>
      <FeatureTourForm
        title="Edit Feature Tour"
        validatedSaveType="update"
        featureTour={new FeatureTour(featureTour)}
      />
    </SinglePanePage>
  )
}

export default EditFeatureTour
